/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
import React, { useCallback, useRef, useState } from "react";

import ReCAPTCHA from "react-google-recaptcha";
import ReactTooltip from "react-tooltip";
import { Formik } from "formik";
import { GoDot, GoLocation } from "react-icons/go";
import { IoMdArrowForward } from "react-icons/io";
import { MdBusiness, MdCheck, MdClose, MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";

import {
  requestGetCondominiusByCode,
  requestGetCondominiusByZipCode,
  validatorSchema,
} from "features/adicionar-unidade/services/addNewUnitApi";

import ContainedButton from "components/layout/form/containedButton";
import RadioField from "components/layout/form/radioField";
import TextField from "components/layout/form/textField";

import { useAdicionarUnidade } from "features/adicionar-unidade/hooks/useAdicionarUnidade";

import BlockMigration from "features/adesao/steps/Registration/BlockMigration";
import CondoUnavailable from "components/MI/adesao/CondoUnavailable";
import {
  ButtonSelect,
  ButtonsContainer,
  CondoContainer,
  CondoIcon,
  CondoSelectedContainer,
  Container,
  Error,
  FieldSelect,
  FormContainer,
  Header,
  HeaderForm,
  InfoCard,
  InputsContainer,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalStyle,
  ReCAPTCHAContainer,
  SelectCondoConatoner,
  SelectTypeContainer,
  Selector,
  SubTitle,
  Title,
  Tooltip,
} from "./styles";

const Registration: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showCondoUnavailableModal, setShowCondoUnavailableModal] =
    useState(false);
  const [reCapcharControler, setReCapcharControler] = useState({
    show: true,
    token: "init",
  });
  const [addressList, setAddressList] = useState([]);
  const [condominiumByZipCode, setCondominiumByZipCode] = useState();
  const [condominiumByCode, setCondominiumByCode] = useState();
  const [numberAattempts, setNumberAattempts] = useState(0);
  const [showModalBond, setShowModalBond] = useState(false);
  const [showModalSwitch, setShowModalSwitch] = useState(false);
  const [isMigrating, setIsMigrating] = useState(false);

  const recaptchaKey = process.env.REACT_APP_RECAPTCHAR_PUBLIC;

  const reCapcharRef = useRef(null);

  const {
    typeSelector,
    condoZipCode,
    condoCode,
    externalUnitId,
    setCondoCode,
    setCondoZipCode,
    setStep,
    setNewUnitData,
  } = useAdicionarUnidade();

  const resetReCapchar = useCallback(() => {
    if (reCapcharRef && reCapcharRef.current && reCapcharRef.current.reset) {
      reCapcharRef.current.reset();
      setReCapcharControler({ ...reCapcharControler, token: null });
    }
  }, [reCapcharControler, setReCapcharControler, reCapcharRef]);

  const recaptcharCount = useCallback(() => {
    setNumberAattempts(numberAattempts + 1);
    if (numberAattempts === 3) {
      setReCapcharControler({ ...reCapcharControler, token: null });
    }
  }, [
    setNumberAattempts,
    numberAattempts,
    setReCapcharControler,
    reCapcharControler,
  ]);

  const handleInputZipCodeChange = useCallback(
    (event, handleChange, setFieldValue) => {
      setIsMigrating(false);
      handleChange(event);
      setFieldValue("condo", "");
      setFieldValue("blockIdSfCep", "");
      setFieldValue("unitCep", "");
      setFieldValue("addressCode", "");
      setCondominiumByZipCode(null);
      setCondominiumByCode(null);
    },
    []
  );

  const handleInputCodeChange = useCallback(
    (event, handleChange, setFieldValue) => {
      setIsMigrating(false);
      handleChange(event);
      setFieldValue("condo", "");
      setFieldValue("blockIdSf", "");
      setFieldValue("unit", "");
      setCondominiumByZipCode(null);
      setCondominiumByCode(null);
    },
    []
  );

  const handleSelectedBlock = useCallback(
    (e, handleChange, setFieldValue, originBy = "code") => {
      const id = e.target.value;
      const { blocks } =
        originBy === "code" ? condominiumByCode : condominiumByZipCode;
      const [selectedBlock] = blocks.filter((block) => block.blockIdSf === id);
      const index = blocks.findIndex((block) => block.blockIdSf === id);
      if (!selectedBlock.units.length) {
        toast.error(
          "Um erro inesperado aconteceu. Tente novamente mais tarde."
        );
        return;
      }

      const selectedBlockName =
        selectedBlock?.name ||
        (selectedBlock.type === "AC" ? "AREA COMUM" : index + 1);

      selectedBlock.name = selectedBlockName;

      if (originBy === "code") {
        setCondominiumByCode({ ...condominiumByCode, selectedBlock });
        setFieldValue("unit", "");
      } else {
        setCondominiumByZipCode({ ...condominiumByZipCode, selectedBlock });
        setFieldValue("unitCep", "");
      }

      handleChange(e);
    },
    [
      condominiumByCode,
      setCondominiumByCode,
      condominiumByZipCode,
      setCondominiumByZipCode,
    ]
  );

  const handleSelectedUnit = useCallback(
    (e, handleChange, originBy = "code") => {
      const id = e.target.value;
      const { selectedBlock } =
        originBy === "code" ? condominiumByCode : condominiumByZipCode;
      const [selectedUnit] = selectedBlock.units.filter(
        (unit) => unit.unitIdSf === id
      );
      if (originBy === "code") {
        setCondominiumByCode({ ...condominiumByCode, selectedUnit });
      } else {
        setCondominiumByZipCode({ ...condominiumByZipCode, selectedUnit });
      }
      handleChange(e);
    },
    [
      condominiumByZipCode,
      setCondominiumByZipCode,
      condominiumByCode,
      setCondominiumByCode,
    ]
  );

  const handleSearchCodeByCode = useCallback(
    async (values) => {
      setIsMigrating(false);
      setCondominiumByCode(null);
      const code = values.code.replace(/[^\d]/g, "");
      if (code) {
        setLoading(true);
        const response = await requestGetCondominiusByCode(
          code,
          "code",
          setShowCondoUnavailableModal
        );

        setIsMigrating(response?.migrating || false);

        setLoading(false);
        setCondoCode(values.code);
        setCondominiumByCode(response);
        setAddressList([]);
        setCondominiumByZipCode(null);
        recaptcharCount();
      }
    },
    [
      setCondominiumByCode,
      requestGetCondominiusByCode,
      setShowCondoUnavailableModal,
    ]
  );

  const handleSearchCodeByZipCode = useCallback(
    async (values) => {
      setCondominiumByZipCode(null);
      const cep = values.cep.replace(/[^\d]/g, "");

      let response;

      setLoading(true);

      if (values.addressCode) {
        response = await requestGetCondominiusByCode(
          values.addressCode,
          "cep",
          setShowCondoUnavailableModal
        );
        setIsMigrating(response?.migrating || false);
        setCondominiumByZipCode(response);
        setAddressList([]);
        recaptcharCount();
      } else if (cep) {
        response = await requestGetCondominiusByZipCode(cep);
        if (response?.data) {
          setAddressList(response.data);
        } else {
          setLoading(false);
        }
        recaptcharCount();
      }

      setLoading(false);
      setCondoZipCode(values.cep);
    },
    [
      setCondominiumByZipCode,
      requestGetCondominiusByZipCode,
      requestGetCondominiusByCode,
      setCondoZipCode,
      setShowCondoUnavailableModal,
    ]
  );

  const handleSearchCode = useCallback(
    (values, errors, setFieldTouched) => {
      setIsMigrating(false);
      if (!loading) {
        resetReCapchar();
        if (reCapcharControler.token) {
          if (values.typeSelector === "code") {
            setFieldTouched("code", true);
            handleSearchCodeByCode(values);
          }
          if (values.typeSelector === "cep" && !errors.cep) {
            setFieldTouched("cep", true);
            handleSearchCodeByZipCode(values);
          }
        }
      }
    },
    [
      reCapcharControler,
      handleSearchCodeByCode,
      handleSearchCodeByZipCode,
      resetReCapchar,
      loading,
    ]
  );

  const buildFormattedObject = ({ condominiumObject, blockIdSf }) => {
    const { condominiumIdSf, address, selectedBlock, selectedUnit, name } =
      condominiumObject;
    address.complement = ` ${selectedBlock.name}, ${selectedUnit.name}`;
    return {
      externalCondominiumId: condominiumIdSf,
      externalBlockId: blockIdSf,
      condominiumName: name,
      externalUnitId: selectedUnit.unitIdSf,
      unitInstanceId: selectedUnit.instanceId,
      name: selectedUnit.name,
      address,
    };
  };

  const handleSubmit = useCallback(
    ({ blockIdSfCep, blockIdSf, typeSelector }) => {
      if (loading) return;
      if (!reCapcharControler.token) {
        return;
      }

      let hasOwner = false;
      let formattedObject = {};

      formattedObject = buildFormattedObject({
        condominiumObject:
          typeSelector === "code" ? condominiumByCode : condominiumByZipCode,
        blockIdSf: typeSelector === "code" ? blockIdSf : blockIdSfCep,
      });

      hasOwner =
        typeSelector === "code"
          ? !!condominiumByCode.selectedUnit.isOccupied
          : !!condominiumByZipCode.selectedUnit.isOccupied;

      setNewUnitData({ ...formattedObject, typeSelector });

      if (hasOwner) {
        setShowModalSwitch(true);
      } else {
        setShowModalBond(true);
      }
    },
    [condominiumByZipCode, condominiumByCode, loading, reCapcharControler]
  );

  return (
    <>
      <Container>
        <Header>
          <Title>Localize a nova unidade</Title>
          <SubTitle>
            Selecione a forma como deseja encontrar o condomínio:
          </SubTitle>
        </Header>
        <Formik
          initialValues={{
            typeSelector: typeSelector || "cep",
            cep: condoZipCode || "",
            code: condoCode || "",
            unit: externalUnitId || "",
            unitCep: externalUnitId || "",
            addressCode: "",
          }}
          validationSchema={validatorSchema}
          onSubmit={handleSubmit}
          render={({
            setFieldTouched,
            setFieldValue,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
          }) => (
            <FormContainer>
              <HeaderForm>
                <SelectTypeContainer>
                  <Selector
                    type="radio"
                    id="typeSelector"
                    name="typeSelector"
                    value="cep"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    defaultChecked={values.typeSelector === "cep"}
                  />
                  <ButtonSelect htmlFor="typeSelector">
                    <div>
                      <GoDot size={19} />
                      Pelo CEP
                    </div>
                  </ButtonSelect>
                  <Selector
                    type="radio"
                    id="condoCode"
                    name="typeSelector"
                    value="code"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    defaultChecked={values.typeSelector === "code"}
                  />
                  <ButtonSelect htmlFor="condoCode">
                    <div>
                      <GoDot size={19} />
                      Código do Condomínio
                    </div>
                  </ButtonSelect>
                </SelectTypeContainer>
                {values.typeSelector === "code" && (
                  <Tooltip>
                    <div data-tip="question" data-for="question">
                      Como encontrar o código?
                      <button type="button">?</button>
                      <ReactTooltip
                        id="question"
                        place="top"
                        type="dark"
                        effect="solid"
                      >
                        O código de autocadastro pode ser obtido através do
                        síndico, administradora do condomínio ou zeladoria
                      </ReactTooltip>
                    </div>
                  </Tooltip>
                )}
                {values.typeSelector === "cep" && (
                  <a
                    href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Tooltip>
                      <div data-tip="question" data-for="question">
                        Não sei meu CEP
                        <button type="button">?</button>
                        <ReactTooltip
                          id="question"
                          place="top"
                          type="dark"
                          effect="solid"
                        >
                          Clique aqui para ser redirecionado para o site dos
                          correios e encontrar o seu CEP.
                        </ReactTooltip>
                      </div>
                    </Tooltip>
                  </a>
                )}
              </HeaderForm>
              <InputsContainer>
                {values.typeSelector === "cep" && (
                  <TextField
                    id="cep"
                    name="cep"
                    inputMode="numeric"
                    label="Digite seu CEP *"
                    placeholder="Digite seu CEP *"
                    // eslint-disable-next-line react/no-unstable-nested-components
                    LeadingIcon={() => <GoLocation size={25} />}
                    mask="99999-999"
                    onBlur={handleBlur}
                    onClick={() => toast.dismiss()}
                    onChange={(e) =>
                      handleInputZipCodeChange(e, handleChange, setFieldValue)
                    }
                    value={values.cep}
                    errorCondition={errors.cep && touched.cep}
                    errorMessage={errors.cep}
                  />
                )}
                {values.typeSelector === "code" && (
                  <TextField
                    id="code"
                    name="code"
                    inputMode="numeric"
                    label="Digite o código do condomínio *"
                    placeholder="Digite o código do condomínio *"
                    // eslint-disable-next-line react/no-unstable-nested-components
                    LeadingIcon={() => <MdContentCopy size={25} />}
                    onBlur={handleBlur}
                    onClick={() => toast.dismiss()}
                    onChange={(e) =>
                      handleInputCodeChange(e, handleChange, setFieldValue)
                    }
                    value={values.code}
                    errorCondition={errors.code && touched.code}
                    errorMessage={errors.code}
                  />
                )}
              </InputsContainer>
              {recaptchaKey &&
                numberAattempts > 3 &&
                reCapcharControler.show && (
                  <ReCAPTCHAContainer>
                    <ReCAPTCHA
                      ref={reCapcharRef}
                      sitekey={recaptchaKey}
                      hl="pt-BR"
                      onChange={(token) =>
                        setReCapcharControler({ ...reCapcharControler, token })
                      }
                    />
                  </ReCAPTCHAContainer>
                )}
              {values.typeSelector === "cep" &&
                values.cep.length > 5 &&
                addressList?.length > 0 &&
                reCapcharControler.token &&
                !condominiumByZipCode && (
                  <CondoContainer>
                    <p>Selecione seu condomínio</p>
                    {addressList.map((address) => (
                      <div key={address.code}>
                        <RadioField
                          id={address.code}
                          name="addressCode"
                          value={address.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          checked={address.code === values.addressCode}
                        />
                        <label htmlFor={address.code}>
                          <strong>{address.name}</strong>
                          <br />
                          {address.address.fullAddress}
                        </label>
                      </div>
                    ))}
                  </CondoContainer>
                )}
              {values.typeSelector === "code" &&
                condominiumByCode &&
                reCapcharControler.token && (
                  <SelectCondoConatoner>
                    <CondoSelectedContainer>
                      <CondoIcon>
                        <MdBusiness size={30} />
                      </CondoIcon>
                      <h1>{condominiumByCode?.name}</h1>
                      <h2>{condominiumByCode?.address?.fullAddress}</h2>
                    </CondoSelectedContainer>
                    {condominiumByCode?.blocks?.length > 0 && (
                      <>
                        <FieldSelect>
                          <div>
                            <select
                              name="blockIdSf"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleSelectedBlock(
                                  e,
                                  handleChange,
                                  setFieldValue,
                                  "code"
                                );
                              }}
                              value={values.blockIdSf}
                            >
                              <option disabled value="">
                                Selecione seu bloco
                              </option>
                              {condominiumByCode?.blocks?.map(
                                (block, index) => (
                                  <option
                                    key={block.blockIdSf}
                                    value={block.blockIdSf}
                                  >
                                    {" "}
                                    {block.name || index + 1}{" "}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          {errors?.blockIdSf &&
                            touched?.blockIdSf &&
                            errors?.blockIdSf && (
                              <Error>{errors?.blockIdSf}</Error>
                            )}
                        </FieldSelect>
                        <FieldSelect>
                          <div>
                            <select
                              name="unit"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleSelectedUnit(e, handleChange, "code");
                              }}
                              value={values.unit}
                            >
                              <option disabled value="">
                                Selecione sua unidade
                              </option>
                              {condominiumByCode.selectedBlock &&
                                condominiumByCode.selectedBlock.units &&
                                condominiumByCode.selectedBlock.units.map(
                                  (unit) => (
                                    <option
                                      key={unit.unitIdSf}
                                      value={unit.unitIdSf}
                                    >
                                      {" "}
                                      {unit.name}{" "}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                          {errors.unit && touched.unit && errors.unit && (
                            <Error>{errors.unit}</Error>
                          )}
                        </FieldSelect>
                      </>
                    )}
                  </SelectCondoConatoner>
                )}
              {values.typeSelector === "cep" &&
                condominiumByZipCode &&
                reCapcharControler.token && (
                  <SelectCondoConatoner>
                    <CondoSelectedContainer>
                      <CondoIcon>
                        <MdBusiness size={30} />
                      </CondoIcon>
                      <h1>{condominiumByZipCode.name}</h1>
                      <h2>{condominiumByZipCode?.address?.fullAddress}</h2>
                    </CondoSelectedContainer>
                    {condominiumByZipCode?.blocks?.length > 0 && (
                      <>
                        <FieldSelect>
                          <div>
                            <select
                              name="blockIdSfCep"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleSelectedBlock(
                                  e,
                                  handleChange,
                                  setFieldValue,
                                  "cep"
                                );
                              }}
                              value={values.blockIdSfCep}
                            >
                              <option disabled value="">
                                Selecione seu bloco
                              </option>
                              {condominiumByZipCode.blocks.map(
                                (block, index) => (
                                  <option
                                    key={block.blockIdSf}
                                    value={block.blockIdSf}
                                  >
                                    {" "}
                                    {block.name || index + 1}{" "}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          {errors.blockIdSf &&
                            touched.blockIdSf &&
                            errors.blockIdSf && (
                              <Error>{errors.blockIdSf}</Error>
                            )}
                        </FieldSelect>
                        <FieldSelect>
                          <div>
                            <select
                              name="unitCep"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleSelectedUnit(e, handleChange, "cep");
                              }}
                              value={values.unitCep}
                            >
                              <option disabled value="">
                                Selecione sua unidade
                              </option>
                              {condominiumByZipCode.selectedBlock &&
                                condominiumByZipCode.selectedBlock.units &&
                                condominiumByZipCode.selectedBlock.units.map(
                                  (unit) => (
                                    <option
                                      key={unit.unitIdSf}
                                      value={unit.unitIdSf}
                                    >
                                      {" "}
                                      {unit.name}{" "}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                          {errors.unit && touched.unit && errors.unit && (
                            <Error>{errors.unit}</Error>
                          )}
                        </FieldSelect>
                      </>
                    )}
                  </SelectCondoConatoner>
                )}
              <ButtonsContainer>
                {!(
                  (values.typeSelector === "code" && !values.unit) ||
                  (values.typeSelector === "cep" && !values.unitCep)
                ) &&
                  isMigrating && <BlockMigration />}
                {(values.typeSelector === "code" && !values.unit) ||
                (values.typeSelector === "cep" && !values.unitCep) ? (
                  <ContainedButton
                    block
                    type="button"
                    continue
                    loading={loading}
                    disabled={isMigrating}
                    id="Avançar"
                    width="100%"
                    // eslint-disable-next-line react/no-unstable-nested-components
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                    onClick={() =>
                      handleSearchCode(values, errors, setFieldTouched)
                    }
                  >
                    {values.typeSelector === "cep" && values.addressCode
                      ? "Continuar"
                      : "Procurar"}
                  </ContainedButton>
                ) : (
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    loading={loading}
                    id="Avançar"
                    width="100%"
                    disabled={isMigrating}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                  >
                    Continuar
                  </ContainedButton>
                )}
              </ButtonsContainer>
            </FormContainer>
          )}
        />
      </Container>
      <ModalStyle
        show={showModalBond}
        onHide={() => setShowModalBond(false)}
        centered
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <h2>Confirme os dados abaixo para continuar</h2>
              <MdClose size={24} onClick={() => setShowModalBond(false)} />
            </div>
            <h1>Deseja prosseguir com a vinculação da unidade?</h1>
          </ModalHeader>
          <ModalBody>
            <CondoIcon>
              <MdBusiness size={30} />
            </CondoIcon>
            <div>
              <p>
                {condominiumByCode && condominiumByCode.name && (
                  <strong>{condominiumByCode.name}</strong>
                )}
                {condominiumByZipCode && condominiumByZipCode.name && (
                  <strong>{condominiumByZipCode.name}</strong>
                )}
                <br />
                {condominiumByCode &&
                  condominiumByCode.address &&
                  condominiumByCode.address.fullAddress}
                {condominiumByZipCode &&
                  condominiumByZipCode.address &&
                  condominiumByZipCode.address.fullAddress}
              </p>
              <InfoCard>
                <p>
                  <strong>Bloco: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedBlock &&
                    condominiumByCode.selectedBlock.name}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedBlock &&
                    condominiumByZipCode.selectedBlock.name}
                </p>
                <p>
                  <strong>Apartamento / Loja: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedUnit &&
                    condominiumByCode.selectedUnit.name}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedUnit &&
                    condominiumByZipCode.selectedUnit.name}
                </p>
              </InfoCard>
            </div>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              color="#E34E2A"
              // eslint-disable-next-line react/no-unstable-nested-components
              LeadingIcon={() => <MdClose size={24} />}
              onClick={() => setShowModalBond(false)}
            >
              Não
            </ContainedButton>

            <ContainedButton
              color="#75B943"
              // eslint-disable-next-line react/no-unstable-nested-components
              LeadingIcon={() => <MdCheck size={24} />}
              onClick={() => setStep(2)}
            >
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      <ModalStyle
        show={showModalSwitch}
        onHide={() => setShowModalSwitch(false)}
        centered
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <h2>Troca de titularidade</h2>
              <MdClose size={24} onClick={() => setShowModalSwitch(false)} />
            </div>
            <h1>
              Deseja prosseguir com a troca de titularidade para a unidade?
            </h1>
          </ModalHeader>
          <ModalBody>
            <CondoIcon>
              <MdBusiness size={30} />
            </CondoIcon>
            <div>
              <p>
                {condominiumByCode && condominiumByCode.name && (
                  <strong>{condominiumByCode.name}</strong>
                )}
                {condominiumByZipCode && condominiumByZipCode.name && (
                  <strong>{condominiumByZipCode.name}</strong>
                )}
                <br />
                {condominiumByCode &&
                  condominiumByCode.address &&
                  condominiumByCode.address.fullAddress}
                {condominiumByZipCode &&
                  condominiumByZipCode.address &&
                  condominiumByZipCode.address.fullAddress}
              </p>
              <InfoCard>
                <p>
                  <strong>DADOS DO RESPONSÁVEL ATUAL DA UNIDADE</strong>
                </p>
                <br />
                <p>
                  <strong>Nome: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedUnit &&
                    condominiumByCode.selectedUnit.owner}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedUnit &&
                    condominiumByZipCode.selectedUnit.owner}
                </p>
                <p>
                  <strong>Documento: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedUnit &&
                    condominiumByCode.selectedUnit.owner_document}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedUnit &&
                    condominiumByZipCode.selectedUnit.owner_document}
                </p>
                <p>
                  <strong>Bloco: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedBlock &&
                    condominiumByCode.selectedBlock.name}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedBlock &&
                    condominiumByZipCode.selectedBlock.name}
                </p>
                <p>
                  <strong>Apartamento / Loja: </strong>
                  {condominiumByCode &&
                    condominiumByCode.selectedUnit &&
                    condominiumByCode.selectedUnit.name}
                  {condominiumByZipCode &&
                    condominiumByZipCode.selectedUnit &&
                    condominiumByZipCode.selectedUnit.name}
                </p>
              </InfoCard>
            </div>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              color="#E34E2A"
              // eslint-disable-next-line react/no-unstable-nested-components
              LeadingIcon={() => <MdClose size={24} />}
              onClick={() => setShowModalSwitch(false)}
            >
              Não
            </ContainedButton>

            <ContainedButton
              color="#75B943"
              // eslint-disable-next-line react/no-unstable-nested-components
              LeadingIcon={() => <MdCheck size={24} />}
              onClick={() => setStep(2)}
            >
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      <CondoUnavailable
        show={showCondoUnavailableModal}
        toggleModal={() => setShowCondoUnavailableModal(false)}
      />
    </>
  );
};

export default Registration;
